goog.provide("shadow.js.shim.module$src$svg$inform$min_svg$default");
shadow.js.shim.module$src$svg$inform$min_svg$default = shadow.js.shim.module$src$svg$inform$min_svg.default;
